module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "companys-section"
  }, [_c('x-table', {
    attrs: {
      "title": _vm.$t('ui.company.title'),
      "emptyStateLabel": _vm.$t('ui.company.empty_state_label'),
      "columns": _vm.columns,
      "tableData": _vm.companies,
      "enableSearch": true,
      "searchKeywords": _vm.searchKeywords,
      "totalResults": _vm.totalCount,
      "pagination": _vm.defaultPagination,
      "showLoader": _vm.loading,
      "tableSettingsName": 'companies',
      "rowsPerPage": [5, 7, 10, 15, 25, 50]
    },
    on: {
      "updateSearch": _vm.updateSearch,
      "updatePagination": _vm.updatePagination,
      "fetchData": _vm.fetchData,
      "clickCell": _vm.clickCell,
      "emitTotalTableCount": _vm.emitTotalTableCount
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8e83696","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/FilterResults/Companies.vue
// module id = 1991
// module chunks = 0